import { getBorderRadius } from '$lib/global/helper/border-radius';
import { getColor, getColorByLightness } from '$lib/helper';

import type { BrandBorderRadius, Theme } from '$lib/types/Theme';

interface Params {
    theme: Theme | undefined;
    contentBackgroundColor?: string;
    contentColor?: string;
}

export interface ResolvedHeaderButtonStyling {
    bgColor: string;
    color: string;
    borderRadiusClass: string;
}

export const resolveHeaderButtonStyling = ({
    theme,
    contentBackgroundColor,
    contentColor,
}: Params): ResolvedHeaderButtonStyling => {
    const isThemeV2 = !!theme?.surface;
    const bgColor = getColor(
        contentBackgroundColor ?? '',
        theme?.buttonBackgroundColor ?? '#000000',
    );
    const textColorFallback =
        isThemeV2 && theme?.primaryText ? theme.primaryText : getColorByLightness(bgColor);
    const color = getColor(contentColor ?? '', textColorFallback);
    const borderRadiusClass = getBorderRadius(
        'button',
        theme?.borderRadius as BrandBorderRadius | undefined,
    );

    return { bgColor, color, borderRadiusClass };
};
